import profile_utilities from "../../../mixins/ProfileUtilities"
import handles_saving from "../../../mixins/HandlesSaving"

import TabSection from "../ui/TabSection"

const is_project_tab_section = {
    mixins: [profile_utilities, handles_saving],
    components: {
        TabSection
    },
    mounted () {
        this.reset_record_info()
    },
    watch: {
        record: "reset_record_info"
    },
    methods: {
        reset_record_info () {
            this.record_id = this.record ? this.record.id : 0
        }
    },
    computed: {
        status_editable () {
            if(this.record && this.record.internal) return true
            if(!this.editable || !this.profile || !this.record) return false
            if(this.is_administrator || this.is_business_manager || this.is_associate_principal || this.is_principal || this.im_pic_or_pm || this.is_db_admin_active) return true
            return false
        }
    },
    props: {
        record: {
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        wizardShown: {
            default: false
        }
    },
    data () {
        return {
            entity: "project"
        }
    }
}

export default is_project_tab_section
